import { useEffect, useState } from "react";
import TableComp from "components/Table"
import { faCircleInfo, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import useAllAssets from "hooks/useAllAssets";
import PaginationComp from "components/Pagination";
import CustomTitle from "components/CustomTitle";
import ButtonIcon from "components/ButtonComp";
import FiltersComp from "./Filters";
import { check_status as c_status } from "data/check_status";
import useForm from "hooks/useForm";
import useInventory from "./hooks/useInventory";
import AddElementModal from "./modals/AddElement";
import DetailsModal from "./modals/Details";
import { IAsset } from "models/Assets";
import CustomLayout from "components/Layout";

const InventoryMain = () => {
    const { theaders, tkeys, values, valuesTypes, baseLines, assetTypes } = useInventory();
    const hookForm = useForm<Record<string, any>>({ base_line_id: 'all', asset_type_id: 'all', check_status: 'all' });
    const { asset_type_id, base_line_id, check_status } = hookForm.params;

    const [modalAdd, setModalAdd] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<boolean>(false);

    // Estado para los parámetros de useAllAssets
    const [assetParams, setAssetParams] = useState({
        pageSize: 10,
        type_id: asset_type_id === 'all' ? undefined : parseInt(asset_type_id),
        assets_base_line_id: base_line_id === 'all' ? undefined : parseInt(base_line_id),
        check_status: check_status === 'all' ? undefined : ([...c_status.map(item => item.value)].includes(check_status) ? check_status as 'Verificado' | 'Parcialmente Verificado' | 'Sin Verificar' : undefined),
    });

    // Hook para obtener los datos de los activos
    const hookAssets = useAllAssets(assetParams);

    // Actualizar los parámetros cuando cambien los valores del formulario
    useEffect(() => {
        setAssetParams({
            pageSize: 10,
            type_id: asset_type_id === 'all' ? undefined : parseInt(asset_type_id),
            assets_base_line_id: base_line_id === 'all' ? undefined : parseInt(base_line_id),
            check_status: check_status === 'all' ? undefined : ([...c_status.map(item => item.value)].includes(check_status) ? check_status as 'Verificado' | 'Parcialmente Verificado' | 'Sin Verificar' : undefined),
        });
    }, [hookForm.params]);
    // Actions
    // const viewPhotograph = () => { }
    // const addComponent = () => { }
    // const assignActivity = () => { }
    const viewDetails = (item: IAsset) => {
        hookAssets.selectItem(item);
        setModalDetails(true);
    }
    // const viewEvaluations = () => { }
    const changeVisibility = () => { }

    return (
        <CustomLayout>
            <div className="container-fluid">
                <CustomTitle
                    title='Inventario de activos ITS'
                    actions={[
                        <ButtonIcon icon={faPlus} tooltip='Agregar elemento' variant='outline-success' onClick={() => setModalAdd(true)} />,
                        <FiltersComp assetBaseLines={baseLines} assetTypes={assetTypes} hookForm={hookForm} />,
                    ]}
                />
                {values &&
                    <TableComp
                        headers={[...theaders, 'Acciones']}
                        keys={tkeys}
                        body={hookAssets.data}
                        loading={hookAssets.loading}
                        loadingItems={hookAssets.pageSize}
                        page={hookAssets.page}
                        badges={[{ index: 1 }, { index: 7 }, { index: 8 }]}
                        badges_values={[
                            { values, col: 'assets_base_line_id' },
                            { values: valuesTypes, col: 'type_id' },
                            { values: c_status, col: 'check_status' }
                        ]}
                        km={[{ index: 2 }]}
                        actions={[
                            // { icon: faPhotoVideo, handleClick: viewPhotograph, tooltip: 'Ver fotografías' },
                            // { icon: faPlus, handleClick: addComponent, tooltip: 'Agregar componente' },
                            // { icon: faSuitcaseRolling, handleClick: assignActivity, tooltip: 'Asignar Actividad', variant: 'outline-success' },
                            { icon: faCircleInfo, handleClick: viewDetails, tooltip: 'Ver detalles', variant: 'outline-primary' },
                            // { icon: faListAlt, handleClick: viewEvaluations, tooltip: 'Ver evaluaciones', variant: 'outline-info' },
                            { icon: faTrashAlt, handleClick: changeVisibility, tooltip: 'Eliminar elemento del inventario', variant: 'outline-danger' }
                        ]}
                    />
                }
                <PaginationComp
                    onChange={hookAssets.changePage}
                    page={hookAssets.page}
                    totalItems={hookAssets.totalItems}
                    defaultPageSize={hookAssets.pageSize}
                />
                {/* Modal: Agregar elemento */}
                {
                    modalAdd && <AddElementModal
                        isOpen={modalAdd}
                        onClose={() => setModalAdd(false)}
                        hookAssets={hookAssets}
                        assetBaseLines={baseLines}
                        assetTypes={assetTypes}
                    />
                }

                {/* Modal para visualizar detalles del inventario */}
                {
                    modalDetails && <DetailsModal
                        onClose={() => setModalDetails(false)}
                        hookAssets={hookAssets}
                    />
                }

            </div>
        </CustomLayout>
    )
}

export default InventoryMain